import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getModel } from '../selectors';
import * as actions from '../actions';
import CabinetDriveComponent from './CabinetDriveComponent';

const CabinetDriveContainer = (props) => {
    return <CabinetDriveComponent {...props} />;
};

const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
};

const CabinetDriveContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(CabinetDriveContainer);

export default React.memo(CabinetDriveContainerConn);
